export const doc = 'application/msword';
export const docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const pdf = 'application/pdf';
